import react from 'react'
import './index.css';

export default function Loader({color = '#FFFFFF', primary = '#FFFFFF'}) {
    return (
        <span id="loader-ado" style={{border: `5px solid ${primary}`, borderBottomColor: color}} className="loader"></span>
    )
}